require('../../shared/singleClipService');

"use strict";

angular.module('app.player.hotkeysController', [
  'app.shared.singleClipService'
])
  .controller('app.player.hotkeysController', [
    '$scope',
    'app.shared.singleClipService',
    '$document',
    '$rootScope',
    function ($scope, singleClip, $document, $rootScope) {

      $scope.enabled = true;
      let init = () => {
        singleClip.getHotKeys()
          .then((response) => {
            let data = response.data;
            if (!data.error) {
              $scope.hotkeys = data;
              $scope.oldKeys = angular.copy($scope.hotkeys);
              $scope.addEventListeners();
            }
          });
      };

      $scope.addEventListeners = () => {
          $document.on('keypress.hotkeysEvents', (key) => {
            if (!keyPressing) {
              hotkeyKeyPress(key);
              keyPressing = true;
            }
          });

          $document.on(
            'keydown.hotkeysEvents',
            /**
             * @param {*} key
             */
            (key) => {
              if (parseInt(key.keyCode) === 32 && key.target === $document.body) {
                key.preventDefault();
              }
            }
          );

          $document.on('keyup.hotkeysEvents', () => {
            keyPressing = false;
          });
        };
        $scope.removeEventListeners = () => {
          $document.off('.hotkeysEvents');
        };

      $scope.hotkeys = null;

      // TODO: add the event to [somewhere]
      // TODO: should this only be active when some button is
      // active in view, like

      let lookupHotkeyEvent = (keyCode) => {
        keyCode = parseInt(keyCode);

        let keyIndex = null;

        for (let i = 0; i < $scope.hotkeys.length; i++) {
          if (parseInt($scope.hotkeys[i].ikeycode) === keyCode) {
            keyIndex = i;
            break;
          }
        }

        if (keyIndex !== null) {
          let key = $scope.hotkeys[keyIndex];
          $rootScope.$broadcast('set_instant_replay', {category_id: key.iclipcategoryid});
        }

        return ($scope.hotkeys[keyIndex]);
      };

      $scope.hotkeysViewClick = (key) => {
        lookupHotkeyEvent(key.ikeycode);
      };

      $scope.enableHotkey = (enable) => {
        $scope.enabled = enable;
      };

      $scope.updateHotKey = (key) => {
        if(key.strkeyboardshortcut.length) {
          key.strkeyboardshortcut = key.strkeyboardshortcut.trim();
          key.ikeycode = key.strkeyboardshortcut.charCodeAt(key.strkeyboardshortcut.length-1);
          key.strascii = key.strkeyboardshortcut.charCodeAt(key.strkeyboardshortcut.length-1);

          let exisiting_shortcut = $scope.hotkeys.filter((hotkey) => {
            return (hotkey.iclipcategoryid !== key.iclipcategoryid)
                && (hotkey.strkeyboardshortcut === key.strkeyboardshortcut)
          });

          if(exisiting_shortcut.length) {
            alert("Shortcut key '"+exisiting_shortcut[0].strkeyboardshortcut+"' already in use for "+exisiting_shortcut[0].strclipcategory+".");
            let oldkey =  $scope.oldKeys.find((hotkey) => {
              return (hotkey.iclipcategoryid === key.iclipcategoryid)
            });

            let hotKeyIndex =  $scope.hotkeys.findIndex((hotkey) => {
              return (hotkey.iclipcategoryid === key.iclipcategoryid)
            });

            $scope.hotkeys[hotKeyIndex] = oldkey;

            if(!$scope.enabled) {
              $scope.enabled = true;
            }
          } else {
            singleClip.updateUserHotKey(key).then(response => {
              let data = response.data;
              if(data.error) {
                alert(data.error);
              }
            });
          }
        }
      };

      let keyPressing = false;
      let hotkeyKeyPress = (key) => {
        lookupHotkeyEvent(key.which);
      };

      $scope.$on('enableHotKeys', (event, data) => {
        $scope.enabled = data;
      });

      $scope.$watch('enabled', () => {
        $scope.enabled ? $scope.addEventListeners() : $scope.removeEventListeners();
      });

      $scope.$on('$destroy', () => {
        $scope.removeEventListeners();
      });

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/player/hotkeys/hotkeysController.js